import Header from "./Header";
import Footer from "./Footer";
import { useEffect } from "react";

export default function PublicLayout({ children }) {
  useEffect(() => { document.body.classList.remove("admin-body"); }, []);
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
